/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  TextField,
} from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  useField,
  useFormikContext,
} from 'formik';
import NumberFormat from 'react-number-format';
import './input.scss';

function MaskInput(props) {
  const [field, meta] = useField(props);
  const { unit } = props;

  const form = useFormikContext();

  let errors = {};

  if (meta.error && (meta.touched || form.submitCount > 0)) {
    errors = { error: true, helperText: meta.error };
  }

  return (
    <NumberFormat
      customInput={TextField}
      {...field}
      {...props}
      {...errors}
      InputProps={{
        endAdornment: <InputAdornment position="end">{unit}</InputAdornment>,
      }}
    />
  );
}

export default MaskInput;
